import _sortBy from "lodash/sortBy";
export var fetchAllCategories = function fetchAllCategories(client) {
  return client.get("/content/entries/category").then(function (value) {
    return _sortBy(value, function (item) {
      return item.name;
    });
  });
};